export const isStreamingPayload = request => (request === null || request === void 0 ? void 0 : request.body) instanceof ReadableStream;